import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { subscribeConsent } from './utils/consentGate'
import { loadGTM, loadAmplitude, initSentry } from './utils/trackerLoaders'

// Trackers are loaded only after the user grants the corresponding cookie
// consent (GDPR / UK GDPR / ePrivacy). Strictly necessary cookies (auth,
// CSRF) load unconditionally because they are required for the Service.
subscribeConsent((choices) => {
  if (choices?.analytics) {
    loadGTM();
    loadAmplitude();
  }
  if (choices?.errorTracking) {
    initSentry();
  }
});

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
